require('./emptyCustomViewOption.scss');

// @vendors
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');

const { BROKER_CUSTOM_WALLET_MY_WALLET_CREATE_NEW_VIEW } = require('constants/index');

const emptyCustomViewOption = () => {
    return (
        <div className="empty-custom-view-option">
            <div className="empty-custom-view-option__msj">
                {formatText('broker-emptyCustomViews')}
            </div>
            <OKButton
                modifier="secondary"
                to={BROKER_CUSTOM_WALLET_MY_WALLET_CREATE_NEW_VIEW}
            >
                <FormattedText value="brokerCustomWallet-configureNewView" />
            </OKButton>
        </div>
    );
};

module.exports = emptyCustomViewOption;
